import React from 'react';
import { Link } from 'react-router-dom';
import {
    BuildingOfficeIcon,
    EnvelopeIcon,
    GlobeAltIcon,
    ShieldCheckIcon,
    DocumentTextIcon
} from '@heroicons/react/24/outline';

const MentionsLegales = () => {
    return (
        <div className="min-h-screen bg-slate-200 pt-20 pb-16">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 rounded-lg mb-6">
                        <DocumentTextIcon className="w-8 h-8 text-white" />
                    </div>
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                        Mentions Légales
                    </h1>
                    <p className="text-lg text-gray-600">
                        Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance en l'économie numérique
                    </p>
                </div>

                <div className="card-surface p-8 md:p-12 space-y-8">
                    <section className="border-b border-gray-200 pb-8">
                        <div className="flex items-start space-x-4 mb-6">
                            <BuildingOfficeIcon className="w-6 h-6 text-blue-600 mt-1 flex-shrink-0" />
                            <div className="flex-1">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">Éditeur du site</h2>
                                <div className="space-y-3 text-gray-700">
                                    <p>
                                        <strong className="text-gray-900">Site :</strong><br />
                                        CV Analyse, accessible à l'adresse{' '}
                                        <a href="https://www.cv-analyse.fr" className="text-blue-600 hover:text-blue-800 underline">
                                            https://www.cv-analyse.fr
                                        </a>
                                    </p>
                                    <p>
                                        <strong className="text-gray-900">Dénomination :</strong><br />
                                        Guillaume Colin
                                    </p>
                                    <p>
                                        <strong className="text-gray-900">Nom commercial :</strong><br />
                                        GC Consulting
                                    </p>
                                    <p>
                                        <strong className="text-gray-900">Forme juridique :</strong><br />
                                        Entrepreneur individuel
                                    </p>
                                    <p>
                                        <strong className="text-gray-900">Siège social :</strong><br />
                                        4 rue de l'église<br />
                                        78950 Gambais<br />
                                        France
                                    </p>
                                    <p>
                                        <strong className="text-gray-900">Numéro SIREN :</strong><br />
                                        932 330 830
                                    </p>
                                    <p>
                                        <strong className="text-gray-900">Numéro SIRET :</strong><br />
                                        932 330 830 00013
                                    </p>
                                    <p>
                                        <strong className="text-gray-900">Code APE (NAF) :</strong><br />
                                        6201Z - Programmation informatique
                                    </p>
                                    <p>
                                        <strong className="text-gray-900">Date d'immatriculation au RNE :</strong><br />
                                        27 août 2024
                                    </p>
                                    <p>
                                        <strong className="text-gray-900">Directeur de publication :</strong><br />
                                        Guillaume Colin
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="border-b border-gray-200 pb-8">
                        <div className="flex items-start space-x-4 mb-6">
                            <EnvelopeIcon className="w-6 h-6 text-blue-600 mt-1 flex-shrink-0" />
                            <div className="flex-1">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact</h2>
                                <div className="space-y-3 text-gray-700">
                                    <p>
                                        <strong className="text-gray-900">Email :</strong><br />
                                        <a href="mailto:contact@guillaume-colin.com" className="text-blue-600 hover:text-blue-800 underline">
                                            contact@guillaume-colin.com
                                        </a>
                                    </p>
                                    <p>
                                        <strong className="text-gray-900">Adresse postale :</strong><br />
                                        4 rue de l'église<br />
                                        78950 Gambais<br />
                                        France
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="border-b border-gray-200 pb-8">
                        <div className="flex items-start space-x-4 mb-6">
                            <GlobeAltIcon className="w-6 h-6 text-blue-600 mt-1 flex-shrink-0" />
                            <div className="flex-1">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">Hébergeurs</h2>
                                <div className="space-y-6 text-gray-700">
                                    <div>
                                        <p className="font-semibold text-gray-900 mb-2">Site (front)</p>
                                        <p>
                                            <strong className="text-gray-900">Nom :</strong> Vercel Inc.
                                        </p>
                                        <p>
                                            440 N Barranca Ave #4133<br />
                                            Covina, CA 91723<br />
                                            États-Unis
                                        </p>
                                        <p>
                                            <a href="https://vercel.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">
                                                https://vercel.com
                                            </a>
                                        </p>
                                    </div>
                                    <div>
                                        <p className="font-semibold text-gray-900 mb-2">API, comptes et fichiers CV (back)</p>
                                        <p>
                                            <strong className="text-gray-900">Nom :</strong> Scalingo SAS
                                        </p>
                                        <p>
                                            13 rue Jacques Peirotes<br />
                                            67000 Strasbourg<br />
                                            France
                                        </p>
                                        <p>
                                            SIRET : 808 665 483 00034
                                        </p>
                                        <p>
                                            <a href="https://scalingo.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">
                                                https://scalingo.com
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="border-b border-gray-200 pb-8">
                        <div className="flex items-start space-x-4 mb-6">
                            <ShieldCheckIcon className="w-6 h-6 text-blue-600 mt-1 flex-shrink-0" />
                            <div className="flex-1">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">Protection des données personnelles</h2>
                                <div className="space-y-4 text-gray-700">
                                    <p>
                                        Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés,
                                        vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.
                                    </p>
                                    <p>
                                        <strong className="text-gray-900">Responsable du traitement :</strong><br />
                                        Guillaume Colin<br />
                                        4 rue de l'église, 78950 Gambais, France<br />
                                        <a href="mailto:contact@guillaume-colin.com" className="text-blue-600 hover:text-blue-800 underline">
                                            contact@guillaume-colin.com
                                        </a>
                                    </p>
                                    <p>
                                        <strong className="text-gray-900">Données collectées :</strong>
                                    </p>
                                    <ul className="list-disc list-inside ml-4 space-y-2">
                                        <li>Identifiants de compte (nom d'utilisateur, adresse email, mot de passe chiffré)</li>
                                        <li>Contenu des CV importés et, le cas échéant, texte d'offre d'emploi collé</li>
                                        <li>Résultats d'analyse (score, conseils, rapport)</li>
                                        <li>Données liées au paiement (montant, statut d'achat), sans numéro de carte</li>
                                        <li>Données de connexion Google si vous choisissez cette option</li>
                                        <li>Données de navigation et d'usage (cookies, mesure d'audience)</li>
                                    </ul>
                                    <p>
                                        <strong className="text-gray-900">Finalités :</strong>
                                    </p>
                                    <ul className="list-disc list-inside ml-4 space-y-2">
                                        <li>Fournir l'analyse de CV, le rapport et les relances</li>
                                        <li>Gérer votre compte et vous identifier</li>
                                        <li>Traiter le paiement du rapport</li>
                                        <li>Vous envoyer les emails de service (compte, résultat, paiement, relance)</li>
                                        <li>Mesurer l'audience et améliorer le service</li>
                                    </ul>
                                    <p>
                                        <strong className="text-gray-900">Sous-traitants :</strong>
                                    </p>
                                    <ul className="list-disc list-inside ml-4 space-y-2">
                                        <li>Scalingo (hébergement des comptes et des CV, Union européenne)</li>
                                        <li>Vercel (hébergement du site)</li>
                                        <li>OpenAI (analyse du contenu des CV par intelligence artificielle ; un transfert hors Union européenne peut avoir lieu)</li>
                                        <li>Stripe (paiement ; aucune donnée bancaire n'est stockée sur CV Analyse)</li>
                                        <li>Brevo (envoi des emails transactionnels)</li>
                                        <li>Google (connexion optionnelle, Tag Manager et Analytics)</li>
                                        <li>PostHog (mesure d'audience, hébergement européen)</li>
                                    </ul>
                                    <p>
                                        <strong className="text-gray-900">Conservation des données :</strong><br />
                                        Les données de compte et d'analyse sont conservées tant que le compte est actif.
                                        Un compte inactif depuis deux ans est supprimé, après un email d'avertissement.
                                        Vous pouvez supprimer votre compte à tout moment depuis votre espace.
                                    </p>
                                    <p>
                                        <strong className="text-gray-900">Vos droits (RGPD) :</strong>
                                    </p>
                                    <ul className="list-disc list-inside ml-4 space-y-2">
                                        <li><strong>Droit d'accès :</strong> obtenir une copie de vos données personnelles</li>
                                        <li><strong>Droit de rectification :</strong> corriger des données inexactes ou incomplètes</li>
                                        <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données</li>
                                        <li><strong>Droit à la limitation :</strong> demander la limitation du traitement</li>
                                        <li><strong>Droit à la portabilité :</strong> récupérer vos données dans un format structuré</li>
                                        <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
                                        <li><strong>Droit de retirer votre consentement :</strong> lorsque le traitement repose sur le consentement</li>
                                    </ul>
                                    <p>
                                        <strong className="text-gray-900">Exercice de vos droits :</strong><br />
                                        Écrivez à{' '}
                                        <a href="mailto:contact@guillaume-colin.com" className="text-blue-600 hover:text-blue-800 underline">
                                            contact@guillaume-colin.com
                                        </a>
                                        {' '}ou utilisez la suppression de compte dans votre espace.
                                        Nous répondons dans un délai d'un mois maximum.
                                    </p>
                                    <p>
                                        <strong className="text-gray-900">Réclamation :</strong><br />
                                        Vous pouvez introduire une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL)
                                        si vous estimez que le traitement de vos données constitue une violation du RGPD.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="border-b border-gray-200 pb-8">
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">Paiement</h2>
                        <div className="space-y-3 text-gray-700">
                            <p>
                                CV Analyse propose un aperçu offert (score et 3 conseils), puis un rapport complet en paiement unique,
                                sans abonnement. Les prix en vigueur sont indiqués sur la page{' '}
                                <Link to="/pricing" className="text-blue-600 hover:text-blue-800 underline">Tarifs</Link>.
                            </p>
                            <p>
                                Les paiements sont traités par Stripe. CV Analyse ne stocke pas vos numéros de carte bancaire.
                            </p>
                        </div>
                    </section>

                    <section className="border-b border-gray-200 pb-8">
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">Analyse par intelligence artificielle</h2>
                        <div className="space-y-3 text-gray-700">
                            <p>
                                Les scores, conseils et documents générés le sont par un système d'intelligence artificielle.
                                Ils sont indicatifs. Ils ne constituent ni une garantie d'entretien, ni une garantie d'embauche,
                                ni un conseil en recrutement.
                            </p>
                        </div>
                    </section>

                    <section className="border-b border-gray-200 pb-8">
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">Propriété intellectuelle</h2>
                        <div className="space-y-3 text-gray-700">
                            <p>
                                L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle.
                                Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
                            </p>
                            <p>
                                Le contenu que vous importez (CV, offre d'emploi) reste le vôtre. Vous autorisez CV Analyse à le traiter
                                uniquement pour fournir le service demandé.
                            </p>
                            <p>
                                La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est formellement interdite sauf autorisation expresse de l'éditeur.
                            </p>
                        </div>
                    </section>

                    <section className="border-b border-gray-200 pb-8">
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">Cookies</h2>
                        <div className="space-y-3 text-gray-700">
                            <p>
                                Des cookies strictement nécessaires assurent la connexion à votre compte et le fonctionnement du site.
                            </p>
                            <p>
                                Des outils de mesure d'audience sont également utilisés : Google Analytics, Google Tag Manager,
                                PostHog et Vercel Analytics. Ils servent à comprendre l'usage du site, pas à vendre vos données.
                            </p>
                            <p>
                                Vous pouvez bloquer ou supprimer les cookies depuis les paramètres de votre navigateur.
                                Cela peut limiter certaines fonctions du compte. Pour une demande relative à ces traitements,
                                écrivez à{' '}
                                <a href="mailto:contact@guillaume-colin.com" className="text-blue-600 hover:text-blue-800 underline">
                                    contact@guillaume-colin.com
                                </a>.
                            </p>
                        </div>
                    </section>

                    <section className="pb-8">
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">Limitation de responsabilité</h2>
                        <div className="space-y-3 text-gray-700">
                            <p>
                                Les informations du site sont aussi précises que possible et mises à jour régulièrement.
                                Elles peuvent toutefois contenir des inexactitudes ou des omissions.
                            </p>
                            <p>
                                L'éditeur ne pourra être tenu responsable des dommages directs ou indirects liés à l'accès au site,
                                à un bug, à une incompatibilité, ou à l'usage des résultats d'analyse.
                            </p>
                        </div>
                    </section>

                    <div className="pt-8 border-t border-gray-200">
                        <Link
                            to="/"
                            className="inline-flex items-center space-x-2 text-blue-600 hover:text-blue-800 font-medium transition-colors"
                        >
                            <span>← Retour à l'accueil</span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MentionsLegales;
